import React from 'react';
import StackedSoilMoistureChart from '../../../../../../components/Highcharts/LineCharts/StackedSoilMoistureChart/StackedSoilMoistureChart';
import SoilMoistureChart from '../../../../../../components/Highcharts/LineCharts/SoilMoistureChart/SoilMoistureChart';
import RootsChart from '../../../../../../components/Highcharts/RootsChart/RootsChart';
import SalinityChart from '../../../../../../components/Highcharts/LineCharts/SalinityChart/SalinityChart';
import SoilTemperatureChart from '../../../../../../components/Highcharts/LineCharts/SoilTemperatureChart/SoilTemperatureChart';

const SoilChartsTab = ({
  sectorId, farmId,
}: {
  sectorId: string,
  farmId: string,
}) => (
  <>
    <StackedSoilMoistureChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
      hideXValues={false}
    />
    <RootsChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={300}
    />
    <SoilMoistureChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
    <SalinityChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
    <SoilTemperatureChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={450}
    />
  </>
);

export default SoilChartsTab;
